// return date day/month/year or ""
function formatDate (date) {
    let formattedDate
    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getDate() +
        '/' +
        (newDate.getMonth() + 1) +
        '/' +
        newDate.getFullYear()
    }
    return formattedDate || "Fecha no definida"
}
export default formatDate;
